export function useCollegeColor({
  org,
}: {
  org: {
    logoColorC: number;
    logoColorH: number | null;
  };
}) {
  // for now keep the same colors for dark and light theme.
  const bgColor = `oklch(97% ${(org.logoColorC / 10).toFixed(4)} ${org.logoColorH ? `${org.logoColorH.toFixed(4)}` : "0"})`;
  const shadowColor = `oklch(80% ${(org.logoColorC / 2).toFixed(4)} ${org.logoColorH ? `${org.logoColorH.toFixed(4)}` : "0"})`;
  const foregroundColor = "oklch(14.5% 0 0)";
  const foregroundSubtleColor = "oklch(55.6% 0 0)";

  return {
    bgColor,
    shadowColor,
    foregroundColor,
    foregroundSubtleColor,
  };
}
